import React, {forwardRef, useRef, useState} from 'react'
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import classNames from "classnames";
import type {BaseUrlModel} from "../../../../infrastructure/models/link/base-url-model";
import {Link} from "../../link/link";
import {LINK_REL} from "../../../consts";

export class ActionButtonProps extends BaseProps {
  onClick: Function;
  className: String;
  bookieHrefModel: BaseUrlModel
}

export const ActionButton = forwardRef((props: ActionButtonProps, forwardRef) => {
  const ref = useRef(forwardRef);
  const [active, setActive] = useState(false);
  const canClick = !!(props.onClick || props.bookieHrefModel);

  const containerProps = {
    ref: forwardRef,
    className: classNames(props.className || 'action-button'),
    onClick: canClick ? (e) => {
      e.stopPropagation()

      ref.current.style.left = `${e.nativeEvent.offsetX}px`;
      ref.current.style.top = `${e.nativeEvent.offsetY}px`;
      setActive(true);

      setTimeout(() => {
        props?.onClick?.();
        setActive(false)
      }, 150);

      return true
    } : undefined,
    style: props.style,
    model: props.bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER
  }

  return (
    <Link {...containerProps}>
      <div ref={ref} className={active ? 'action-button-circle' : ''}/>
      {
        props.children
      }
    </Link>
  )
})
